import { gateway } from "../../../gateway";
import { KanbanPage } from "../interfaces/kanbanPage.interface";

/**
 * Action to fetch all kanban pages
 *
 * Backend endpoint: GET /kanban-pages/self
 * Response format: { status: 200, message: "Kanban pages", data: KanbanPage[] }
 */
export const getKanbanPagesAction = async (): Promise<KanbanPage[]> => {
  try {
    const response = await gateway.get("/kanban-pages/self");
    // Backend returns { status, message, data } where data is the array
    const pages = response.data?.data || response.data;
    // Ensure we return an array
    return Array.isArray(pages) ? pages : [];
  } catch (error: any) {
    console.error("Error fetching kanban pages:", error);
    // Re-throw with a more descriptive error message
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to fetch kanban pages";
    throw new Error(errorMessage);
  }
};
